<div class="modal-overlay" 
     [class.open]="isOpen" 
     (click)="onOverlayClick($event)"
     *ngIf="isOpen">
  
  <div
    class="modal-container"
    [style.width]="width"
    [ngClass]="customClass"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="title ? 'modal-title' : null"
    [attr.aria-describedby]="description ? 'modal-description' : null"
    [cdkTrapFocus]="trapFocus"
    [cdkTrapFocusAutoCapture]="trapFocus">
    <!-- Close Icon -->
    <button 
      *ngIf="showCloseIcon && isRemovable"
      class="modal-close-icon"
      (click)="closeModal()"
      type="button">
      <lucide-angular [img]="closeIcon" size="24" [attr.aria-label]="'generic.close' | translate" role="img"></lucide-angular>
      <span class="modal-close-text">{{ 'generic.close' | translate }}</span>
    </button>

    <!-- Modal Content -->
    <div class="modal-content">
      <!-- Title -->
      <h1 *ngIf="title" id="modal-title" class="modal-title">{{ title }}</h1>
      <hr class="modal-divider">
      
      <!-- Subtitle -->
      <h2 *ngIf="subtitle" class="modal-subtitle">{{ subtitle }}</h2>
      
      <!-- Description -->
      <p *ngIf="description" id="modal-description" class="modal-description">{{ description }}</p>
      
      <!-- Custom Content -->
      <ng-content></ng-content>
    </div>

    <!-- Modal Actions -->
    <div class="modal-actions" *ngIf="actionButtonText || (closeButtonText && isRemovable)">
      <button
        *ngIf="closeButtonText && isRemovable"
        [ngClass]="{'modal-button--align-left': !!closeButtonText}"
        class="modal-button modal-button--outline"
        type="button"
        (click)="closeModal()">
        {{ closeButtonText }}
      </button>
      
      <button 
        *ngIf="actionButtonText"
        [ngClass]="{'modal-button--align-right': !!closeButtonText && isRemovable}"
        class="modal-button modal-button--primary"
        type="button"
        [disabled]="actionButtonDisabled"
        (click)="actionModal()">
        {{ actionButtonText }}
      </button>
    </div>
  </div>
</div> 